/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "client": {
        "nested": {
          "push": {
            "nested": {
              "ServerCompletedVersion": {
                "values": {
                  "UNKNOWN_VERSION": 0,
                  "CASH_APP_V0": 1,
                  "CASH_APP_V1": 2
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.client?.nested?.push?.nested?.ServerCompletedVersion) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ServerCompletedVersion @ squareup/client/push/push.proto at 54:1
 */
export const ServerCompletedVersion = $root.lookupEnum('squareup.client.push.ServerCompletedVersion').values;